import { Field, FieldType, OptionsField, Primitive, TextField } from './types';

// \u0009 tab
// \u000A LF
// \u0020-\u007E basic latin letters, digits and symbols excludes control chars
// \u00A0-\u00FF latin-1 supplement punctuation, symbols and characters
// export const GENERAL_CHAR_REGEX = /^[\u0009\u000A\u0020-\u007E\u00A0-\u00FF]*$/;
// allow whitespace and anything that isn't a C1 control char
export const GENERAL_CHAR_REGEX = /^[\s\P{Cc}]*$/u;

export const validate = (field: Field, value: Primitive): string | null => {
  if (value === undefined || value === null || String(value).trim() === '') {
    if (field.mandatory) {
      return 'required';
    }
    return null;
  }

  if (typeof value === 'string' && !GENERAL_CHAR_REGEX.test(value)) {
    return 'invalid character(s)';
  }

  if (field.encrypted) {
    return null; // TODO - can't validate encrypted values
  }

  const numberValue = typeof value === 'string' ? Number(value) : typeof value === 'boolean' ? (value ? 1 : 0) : value;
  if (
    [FieldType.Decimal, FieldType.Integer].includes(field.type) &&
    (Number.isNaN(numberValue) || !Number.isFinite(numberValue))
  ) {
    return `must be a valid number`;
  }
  if (typeof field.min === 'number' && numberValue < field.min) {
    return `must be at least ${field.min}`;
  }
  if (typeof field.max === 'number' && numberValue > field.max) {
    return `must be at most ${field.max}`;
  }

  if (typeof field.regex === 'string' && typeof value === 'string') {
    const regexp = new RegExp(field.regex);
    if (!regexp.test(value)) {
      return `must match pattern ${field.regex}`;
    }
  }

  const minLength = (field as TextField).minLength;
  if (typeof minLength === 'number' && typeof value === 'string' && value.length < minLength) {
    return `must be at least ${minLength} characters long`;
  }

  const maxLength = (field as TextField).maxLength;
  if (typeof maxLength === 'number' && typeof value === 'string' && value.length > maxLength) {
    return `must be at most ${maxLength} characters long`;
  }

  const options = (field as OptionsField).options;
  if (options && !options.find((option) => option.id === String(value))) {
    return `not one of the allowed options`;
  }

  return null;
};

export const validateEmailAddress = (emailAddress: string | null | undefined): string | null => {
  if (!emailAddress || emailAddress.trim() === '') {
    return null;
  }
  if (!emailAddress.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/gm)) {
    return 'not a valid email address';
  }
  return null;
};
